import moment from 'moment';
import * as React from 'react';
import { SmartRow } from '../../types';

interface Props {
  row: SmartRow;
}

export const Date: React.FC<Props> = (props) => {
  const { row } = props;

  if (row.type === 'placeholder') {
    return null;
  }

  const { date } = row;
  const m = moment(date);
  return <span>{m.format('DD-MMM-YYYY')}</span>;
};
Date.displayName = 'SmartPerDiem.Table.Cell.Date';
